<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left2Data: {
      type: Object,
      default: () => {},
    }
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.left2Data,props.name,props.color);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init() {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    let result = [{ name: "10/1", ai: 6649 },
    { name: "10/2", ai: 5992},
    { name: "10/3", ai: 6375},
    { name: "10/4", ai: 7912},
    { name: "10/5", ai: 1174},
    { name: "10/6", ai: 1193},
    { name: "10/7", ai: 1169},
    { name: "10/8", ai: 1622},
    { name: "10/9", ai: 3788},
    { name: "10/10", ai: 4339}]

    let xData = result.map((item) => { return item.name });
    let keys = ['ai'], seriesData = [];
    let color = ['0, 254, 210','0, 124, 250']
    keys.forEach((key,index) => {
      seriesData.push({
          name: key + "数",
          data: result.map((item) => { return item[key] }),
          type: "line",
          yAxisIndex: 0,
          symbol: "none",
          symbolSize: 7,
          barWidth: 14,
          splitNumber: 6,
          smooth: false,
          itemStyle:{
            "color": `rgba(${color[index]},1)`
          },
          lineStyle:{
            color: `rgba(${color[index]},1)`,
            width: 1
          },
          areaStyle:{
            opacity: 1,
            color:{
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              type: "linear",
              global: false,
              colorStops: [{
                    offset: 0,
                    color: `rgba(${color[index]},0.35)`
                },{
                    offset: 0.8,
                    color: "rgba(6, 8, 41,.1)"
                }]
            },
            shadowColor: "rgba(0, 0, 0, 0.1)",
            shadowBlur: 10
          }
      })
      seriesData.push({
          name: key + "数",
          data: [{
            coords: result.map((item) => { return [item.name, item[key]] }),
          }],
          type: "lines",
          coordinateSystem: "cartesian2d",
          zlevel: 1,
          polyline: true,
          smooth: true,
          symbol: "circle",
          effect:{
            show: true,
            trailLength: 0.4,
            symbol: "circle",
            period: 8,
            symbolSize: 8
          },
          lineStyle:{
            normal:{
                color: `rgba(${color[index]},1)`,
                width: 0,
                opacity: 0,
                curveness: 0
            }
          }
      })
    })

    this.state.chart.setOption({
      tooltip:{
        trigger: "axis",
        axisPointer:{
          type: "line"
        },
        padding: [8, 15],
        // "backgroundColor": "rgba(12, 51, 115,0.8)",
        // "borderColor": "rgba(3, 11, 44, 0.5)",
        textStyle:{
          color: "#000"
        }
      },
      grid:{
        show: true,
        top: 50,
        left: 20,
        right: 30,
        bottom: 10,
        containLabel: true,
        borderWidth: 0,
          // "backgroundColor": "rgba(12, 45, 81, .3)"
      },
      legend:{
        show: false,
      },
      // "dataZoom": [{
      //   "show": true,
      //   "start": 0,
      //   "end": 100,
      //   "bottom": 10,
      //   "right": 8,
      //   "left": 30,
      //   "height": 20,
      //   "borderColor": "transparent",
      //   "showDetail": false,
      //   "backgroundColor": "rgba(64, 169, 255, 0.1)",
      //   "handleStyle":{
      //       "color": "rgba(64, 169, 255, 0.57)"
      //   },
      //   "moveHandleSize": 0,
      //   "moveHandleStyle":{
      //     "opacity": 0
      //   },
      //   "dataBackground":{
      //     "areaStyle":{
      //       "color": "rgba(64, 169, 255, 1)"
      //     }
      //   }
      // },{
      //     "type": "inside",
      //     "dataBackground": "#0ff",
      //     "showDetail": false
      //   }],
      xAxis:{
        type: "category",
        boundaryGap: false,
        data: xData,
        axisPointer:{
          handle:{
              show: false
          }
        },
        axisLine:{
          textStyle: {
            color: '#fff',//坐标值得具体的颜色,
            fontSize: '12px'
          },
          interval:0
        },
        axisTick:{
          show: true
        },
        axisLabel: {
          color: '#A1A7B3',
          interval: 0, // 横轴信息全部显示
        },
      },
      yAxis: [{
        show: true,
        nameGap: 0,
        type: "value",
        minInterval: 0,
        splitLine:{
          show: true,
          lineStyle: {
              color: 'rgba(255,255,255,.1)'
          }
        },
        axisTick:{
            show: false
        },
        minorSplitLine:{
            show: false
        },
        axisLine:{
            show: false
        },
        nameTextStyle:{
          fontSize: 14,
          padding: [0, 0, 0, -15],
          align: "left",
          color: "#AEC6DF;"
        },
        axisLabel:{
          color: "#AEC6DF"
        }
      }],
      series: seriesData
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
